import React from "react";
import ThemeColorOption from "./theme-color-option";

export interface ThemeColor {
    id: string;
    colorClass: string;
}

interface ThemeSectionProps {
    colors: ThemeColor[];
    selectedId: string;
    onSelect: (id: string) => void;
}

const ThemeSection: React.FC<ThemeSectionProps> = ({
    colors,
    selectedId,
    onSelect,
}) => {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h2 className="text-lg font-semibold text-on-surface">
                    Motyw
                </h2>
                <p className="text-base text-on-surface/80 leading-5 font-normal">
                    Dostosuj kolorystykę aplikacji, aby lepiej pasowała do Twojej marki.
                </p>
            </div>

            <div className="flex flex-wrap gap-2">
                {colors.map((color) => (
                    <ThemeColorOption
                        key={color.id}
                        id={color.id}
                        colorClass={color.colorClass}
                        isSelected={color.id === selectedId}
                        onSelect={() => onSelect(color.id)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ThemeSection;


